export default "__VITE_ASSET__wY7txXDI__"